import { useContext } from 'react';

import { CreateGoalTemplateContext } from './create-goal-template-context';

export const useOpenCreateGoalTemplateDialog = () => {
  const { onCreateDialog } = useContext(CreateGoalTemplateContext);
  return onCreateDialog;
};
